// @flow
import { equals } from 'ramda'

// eslint-disable-next-line no-confusing-arrow
export const setPluralForm = (count: number, noun: string, suffix: string = 's'): string =>
  equals(count, 1) ? noun : `${noun}${suffix}`
